import { Box, Link as MuiLink, Typography } from '@mui/material';
import { header_content } from '../../../../../data/general_texts';
import { FaAngleRight } from 'react-icons/fa6';
import { useGoldPrice } from '../../../../../contexts/GoldPriceProvider';
import { moneyMask } from '../../../../../utils/functions';
import { useAuth } from '../../../../../contexts/AuthProvider';

const GoldQuote = () => {
    const { goldPrice } = useGoldPrice();

    return (
        <>
            <Typography component="span" sx={styles.quoteLabel}>
                Cotação do ouro hoje:
            </Typography>
            <Typography component="span" sx={styles.quoteValue}>
                {moneyMask(String(goldPrice ?? ''))}
            </Typography>
        </>
    );
};

const PartnerCta = ({ compact }) => (
    <>
        {!compact && (
            <Typography component="span" sx={styles.ctaLabel}>
                {header_content.promotion_banner_content.text}
            </Typography>
        )}
        <MuiLink
            color="secondary"
            href={header_content.promotion_banner_content.cta_link}
            target="_blank"
            rel="noopener noreferrer"
            sx={styles.cta}
        >
            {header_content.promotion_banner_content.cta}
            <Box component={FaAngleRight} sx={{ ml: 0.5 }} />
        </MuiLink>
    </>
);

export const PromotionBanner = () => {
    const { isAuthenticated } = useAuth();

    return (
        <>
            <Box sx={{ ...styles.bar, ...styles.desktop }}>
                {isAuthenticated ? <GoldQuote /> : <PartnerCta />}
            </Box>
            <Box sx={{ ...styles.bar, ...styles.mobile }}>
                {isAuthenticated ? <GoldQuote /> : <PartnerCta compact />}
            </Box>
        </>
    );
};

const styles = {
    bar: {
        bgcolor: 'primary.main',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 0.75,
        py: 0.65,
        px: 1.5,
        textAlign: 'center',
    },
    desktop: {
        display: {
            xs: 'none',
            md: 'flex',
        },
    },
    mobile: {
        display: {
            xs: 'flex',
            md: 'none',
        },
    },
    quoteLabel: {
        color: 'common.white',
        fontSize: '0.75rem',
        letterSpacing: '0.04em',
    },
    quoteValue: {
        color: 'secondary.main',
        fontWeight: 600,
        fontSize: '0.75rem',
        letterSpacing: '0.04em',
        fontVariantNumeric: 'tabular-nums',
    },
    ctaLabel: {
        color: 'common.white',
        fontSize: '0.75rem',
        letterSpacing: '0.02em',
        mr: 0.5,
    },
    cta: {
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: {
            xs: '0.75rem',
            md: '0.8125rem',
        },
        fontWeight: 600,
    },
};

export default PromotionBanner;
